import {inject, Injectable} from './di';
import {ConfigService} from './config/config-service';
import {distinctUntilChanged, map} from 'rxjs';
import {AppInitializeService} from './app-initialize-service';
import {Logger} from './logger';

@Injectable()
export class ScreenSizeService implements AppInitializeService {
  private readonly configService = inject(ConfigService);
  private readonly logger = inject(Logger);

  private ww: number = 1280;
  private wh: number = 720;
  private hh: number = 182; // or 154
  private pw: number = 860;

  public get screenSize() {
    return {
      ww: this.ww,
      wh: this.wh,
      hh: this.hh,
      pw: this.pw,
    };
  }

  constructor() {
    // TODO legacy
    window.ww = this.ww;
    window.wh = this.wh;
    window.hh = this.hh;
    window.pw = this.pw;
  }

  public async init(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.configService.config$
        .pipe(
          map((c) => c.menu),
          distinctUntilChanged(),
        )
        .subscribe({
          next: (menuStyle) => {
            this.ww = 1280;
            this.wh = 720;
            this.pw = 860; //TODO: сделать для классики, проверить для скандика

            if (menuStyle === 'metro' || menuStyle === 'scandic') {
              this.hh = 182;
            } else {
              this.hh = 154;
            }
            document.title = `Hoteza (${this.ww}x${this.wh})`;

            this.logger.debug(`[ScreenSizeService] Screen size initialized successfully: ${this.ww}x${this.wh}`);

            window.ww = this.ww;
            window.wh = this.wh;
            window.hh = this.hh;
            window.pw = this.pw;

            resolve(true);
          },
          error: () => {
            // NOTE: error will be handled in other place anyway
            resolve(false);
          },
        });
    });
  }
}

declare global {
  interface Window {
    ww: number;
    wh: number;
    pw: number;
    hh: number;
  }
  let ww: number;
  let wh: number;
  let pw: number;
  let hh: number;
}
